module.exports = require("./es-NI.d.ts");